var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.75,
    y: 66.5,
    width: 150,
    height: 95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 95.68,
    y: 94.3,
    width: 26.15,
    height: 14.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "78.25 66 78.25 49 139.25 49 139.25 66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.25,
    y1: 101,
    x2: 183.75,
    y2: 101
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.75,
    y1: 101,
    x2: 82.25,
    y2: 101
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/BRIEFCASE.874a233a116ba72fa932c7cb7ca46bf7.svg";
export { ForwardRef as ReactComponent };